<template>
  <div class="preview">
    <div class="top-nav-bar">
      <van-navBar :title="pageTitle || '预览'" @click-left="$router.back()">
        <i class="icon back-arrow" slot="left"></i>
      </van-navBar>
    </div>
    <div v-html="detail.content || ''" class="content rich-text"></div>
  </div>
</template>

<script>
import { NavBar } from 'vant';
export default {
  name: 'Preview',
  components: { 'van-navBar': NavBar },
  data () {
    return {
      pageTitle: '',
      detail: {}
    };
  },
  created () {
    this.$http.get(`courseTeach/pastRead/detail?id=${this.$route.params.id}`, { showLoading: true }).then((res) => {
      this.pageTitle = res.data.detail.title;
      this.detail = res.data.detail;

      this.$wxShare({
        // url: window.href, // 网址，默认使用 window.location.href
        title: this.detail.title, // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
        desc: `<span v-html>${this.detail.content}</span>` || '广东教育出版社', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
        imgUrl: this.detail.coverImage // 图片, 默认取网页中第一个img标签
      });
    });
  }
};
</script>

<style lang="less" scoped>
.preview {
  .top-nav-bar {
    flex-shrink: 0;
    width: 100%;
    height: 94px;

    /deep/.van-nav-bar {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      z-index: 999;
      width: 100%;
      height: 94px;
      margin: auto;
      background-color: #fff;

      &::after {
        border: none;
      }

      .van-nav-bar__title {
        font-size: 34px;
        font-weight: bold;
        line-height: 94px;
        color: #222;
        color: #1a1a1a;
      }

      .van-nav-bar__left {
        left: 0;
      }

      .van-nav-bar__right {
        right: 0;
      }

      .van-nav-bar__left,
      .van-nav-bar__right {
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 94px;
        padding: 0 30px;
      }

      .back-arrow {
        width: 32px;
        height: 32px;
        background-image: url("~@/assets/images/icon_backArrow_01.png");
        background-size: contain;
      }
      .btn {
        width: 96px;
        height: 56px;
        background: linear-gradient(93deg, #2E86FF 0%, #5FA9FF 100%);
        border-radius: 8px;
        font-size: 24px;
        font-weight: 500;
        line-height: 46px;
        color: #fff;
      }
    }
  }
  .content {
    padding: 40px;
    font-size: 20px;
  }
}
</style>